/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./version-name.vue?vue&type=template&id=3837c222&scoped=true&"
import script from "./version-name.vue?vue&type=script&lang=ts&"
export * from "./version-name.vue?vue&type=script&lang=ts&"
import style0 from "./version-name.vue?vue&type=style&index=0&id=3837c222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837c222",
  null
  
)

export default component.exports